<template>
	<div class="col" align-x="center" gutter="35">
		<h1 class="center">註冊個人帳號</h1>
		<div class="message center bg-background2 color-text2">
			<p>請至您的信箱查看帳號註冊信 按照信件步驟，完成註冊</p>
		</div>
	</div>
</template>

<script>
import { mapActions } from 'vuex';
export default {
	data() {
		return {}
	},
	methods: {
		...mapActions("user", ["cleanToken"]),
	},
	created() {
		this.cleanToken();
	}
}
</script>

<style lang="scss" scoped>
.message {
	max-width: 470px;
	padding: 0 7%;
	text-align: center;
}
</style>
